import React, { FunctionComponent, useState, useEffect } from 'react';
import { Accordion, Nav } from 'react-bootstrap';
import { useHistory, Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import PlansBanner from '../../DashboardComponents/plansBanner';
import Cookies from 'universal-cookie';
//redux
import { useDispatch, useSelector } from 'react-redux';
import { updateSendToNameSection, updateSendToNameSubSection } from '../../../redux/slices/KnowDivInScreen';
import "./style.css"


// El buscador (Algolia) se ha movido a la cabecera: components/DocsSearch/DocsSearch.tsx

import "../../../assets/css/baseLayout.css"
import { gray } from 'd3';


const cookies = new Cookies();

// ESTE ES EL SIDEBAR DE LOS DOCUMENTOS

type SideProps = {
  sider: any,
  active?: string,
  cambio?: () => void
};

const ApiSideBar: FunctionComponent<SideProps> = ({ sider, active, cambio }: SideProps) => {


  const sendToNameSection = useSelector((state: any) => state.nameDiv.sendToNameSection)
  const nameDiv = useSelector((state: any) => state.nameDiv.name)
  const dispatch = useDispatch()

  // Call useLocation at the top level
  const location = useLocation();

  const [isLoggedIn, setLogged] = useState(false);
  const [navMenu, setNav] = useState([]);
  const [expanded, setExpanded] = useState('');
  const { menus } = sider;
  let { basePath } = sider;
  //To use search algolia
  const indexAlgolia = location.pathname.split('/')[1] || ''; // Obtiene la primera parte de la ruta actual

  // Pantalla estrecha (< 1024px): el sidebar se oculta y se abre
  // como panel lateral desde la franja que hay bajo la cabecera
  const [drawerOpen, setDrawerOpen] = useState(false);
  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);


  const history = useHistory();

  const routerLink = (e) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(e.currentTarget.pathname);
    cambio();
  }

  const [divSelected, setDivSelected] = useState(null);


  // Con el panel abierto: Esc lo cierra y la página no hace scroll por detrás
  useEffect(() => {
    if (!drawerOpen) return;
    // Esc cierra solo la capa de arriba: con el buscador abierto encima, lo cierra él
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !document.body.classList.contains('modal-open')) closeDrawer();
    };
    window.addEventListener('keydown', onKey);
    // Solo se bloquea <html>, que es el que hace scroll en el portal. Bloquear también
    // <body> (que tiene height: 100% por avapcloud.css) recortaba la página a la
    // altura de la ventana y el scroll volvía arriba del todo al abrir el panel.
    // Se guarda el valor anterior por si otra capa (buscador) ya lo había bloqueado
    const html = document.documentElement;
    const prevOverflow = html.style.overflow;
    html.style.overflow = 'hidden';

    // Al abrir, la lista se desplaza hasta dejar centrada la sección que se está
    // leyendo (si no, siempre empezaba arriba del todo). Se mueve solo la lista:
    // scrollIntoView movería también la página
    const sidebar = document.getElementById('sidebar');
    const active = sidebar && sidebar.querySelector('.item_selected');
    if (sidebar && active) {
      const offset = active.getBoundingClientRect().top - sidebar.getBoundingClientRect().top;
      // 'instant': el portal tiene scroll-behavior: smooth y se vería la lista bajar animada
      sidebar.scrollTo({ top: sidebar.scrollTop + offset - sidebar.clientHeight / 2, behavior: 'instant' as any });
    }

    return () => {
      window.removeEventListener('keydown', onKey);
      html.style.overflow = prevOverflow;
    };
  }, [drawerOpen]);
  // Si la ventana se ensancha con el panel abierto, se cierra
  useEffect(() => {
    const onResize = () => { if (window.matchMedia('(min-width: 1024px)').matches) closeDrawer(); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const checkForActivedSupport = async () => {
    try {

      if (!isLoggedIn) {
        const supportScript = document.getElementById('ze-snippet') as HTMLScriptElement;

        if (!supportScript) { // si no existe el script
          const script = document.createElement('script');

          script.id = 'ze-snippet';

          const user = cookies.get('101Obex');

          if (!user) {
            script.src = 'https://static.zdassets.com/ekr/snippet.js?key=ff86f044-4911-46f6-91fc-fd90fa14cd08'
          }
          script.async = true;

          document.body.appendChild(script);
        }
      }

    } catch (error) {
      console.error('ERROR GETTING ACTIVED SUPPORT ', error);
    }
  }

  const loadNav = () => {
    const navs = menus.map((nav) => {
      // debugger
      const { id, links, icon, title } = nav;

      let ident = nav.id;
      if (ident == undefined) ident = Math.random();
      // debugger
      return (
        <Nav key={'apisidebar' + nav.id} className="flex-column mb-2">
          <div className={`px-0 title-nav d-flex justify-content-between ${expanded == id ? 'link-active' : ''}`}>
            {/* {nav.icon &&
              <img className={'pr-2'} src={`/src/assets/img/iconosv2/icon-${icon}.png`} />
            } */}
            <div className='text-capitalize hover_name_section' title={title} onClick={() => getAndSetNameSection(id)} >{title.toLowerCase()}</div>
            <div>
              {expanded == id ? (

                <div>
                  {/* <svg role="img" aria-hidden="false" aria-label="Dropdown open" width={"12px"} height={"12px"} viewBox="0 0 16 16" fill="#6c7688" xmlns="http://www.w3.org/2000/svg" ><path fill-rule="evenodd" clip-rule="evenodd" d="M.381 4.381a.875.875 0 0 1 1.238 0L8 10.763l6.381-6.382A.875.875 0 1 1 15.62 5.62l-7 7a.875.875 0 0 1-1.238 0l-7-7a.875.875 0 0 1 0-1.238Z"></path></svg>*/}
                </div>

              ) : (
                <div>
                  {/* <svg width={"8px"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" /></svg> */}
                  {/*<svg role="img" aria-hidden="false" aria-label="Dropdown closed" width={"12px"} height={"12px"} viewBox="0 0 16 16" fill="#6c7688" xmlns="http://www.w3.org/2000/svg" ><path fill-rule="evenodd" clip-rule="evenodd" d="M4.381.381a.875.875 0 0 0 0 1.238L10.763 8 4.38 14.381a.875.875 0 1 0 1.24 1.239l7-7a.875.875 0 0 0 0-1.238l-7-7a.875.875 0 0 0-1.238 0Z"></path></svg>*/}
                </div>


              )

              }

            </div>
          </div>
          {/* Todas las secciones desplegadas */}
          {(
            <div>

              <Nav.Item className="ml-2">
                {links.map(link => {
                  const { title, path } = link;
                  const divId = `${id}-${path}`;
                  // Con todas las secciones abiertas hay que comparar sección + path:
                  // el mismo path puede repetirse en varias secciones
                  let itemSelected = nameDiv === divId;

                  // console.log("partes", partes);
                  // console.log("path", path);


                  return <Link
                    key={'linapisidebar' + link.path}
                    className={`pl-2 ${itemSelected ? "item_selected rounded" : ""} `}
                    // # con el id completo de la sección (menú + ruta): con solo la ruta,
                    // si se repetía en varias secciones el scroll iba a la primera
                    to={`/${basePath}#${divId}`}
                    title={title}
                    onClick={() => {
                      getAndSetNameSubSection(divId); closeDrawer();
                      // Si ya se estaba en esa sección (mismo #), ni el hash ni redux
                      // cambian y no se hacía scroll: se hace aquí directamente
                      if (decodeURIComponent(window.location.hash.slice(1)) === divId) {
                        const target = document.getElementById(divId);
                        if (target) target.scrollIntoView();
                      }
                    }}
                  >
                    <span className={` ${itemSelected ? "item_selected_color" : ""} text-capitalize`}>{title}</span>
                  </Link>;
                })}
              </Nav.Item>
            </div>
          )}

        </Nav>
      )
    })
    setNav(navs);
  }

  const getAndSetNameSection = (id: string) => {

    setExpanded(id)
    // dispatch(updateSendToNameSection(id));

  };

  const getAndSetNameSubSection = (divId: string) => {
    console.log('Subsection selected:', divId);
    dispatch(updateSendToNameSubSection(divId));

    // setExpanded(id)
    dispatch(updateSendToNameSubSection(divId));

  };

  useEffect(() => {
    console.log(sider);

    const user = cookies.get('101Obex');
    if (user) {
      setLogged(true);
    } else {
      setLogged(false);
    }
    loadNav();
    // const defaultActive = menus[0].id;
    // setExpanded(defaultActive);
    checkForActivedSupport();

  }, []);

  useEffect(() => {
    loadNav();
  }, [expanded]);

  //Check when value change
  useEffect(() => {
    const partes = nameDiv ? nameDiv.split('-') : "";
    if (partes.length > 0) {
      // console.log("if expanded", partes);

      setExpanded(partes[0]);
      loadNav();
    } else {
      setExpanded('');
      // loadNav();
    }

  }, [nameDiv]);

  // Título de la franja: el ítem del menú que se está leyendo
  const currentTitle = (() => {
    for (const menu of menus || []) {
      const link = (menu.links || []).find(l => `${menu.id}-${l.path}` === nameDiv);
      if (link) return link.title;
    }
    return menus && menus[0] ? menus[0].title : 'Menu';
  })();

  return (
    <>
      {/* Franja bajo la cabecera en pantalla estrecha: abre el menú como panel lateral */}
      <button type="button" className="docs-subbar" onClick={openDrawer} aria-label="Open menu" aria-expanded={drawerOpen}>
        <span className="docs-subbar__icon" aria-hidden="true"><span /><span /></span>
        <span className="docs-subbar__title">{currentTitle}</span>
      </button>

      <div className={`docs-drawer-overlay ${drawerOpen ? 'is-open' : ''}`} onClick={closeDrawer} />

      <div className={`position-fixed docs-sidebar-wrapper ${drawerOpen ? 'is-open' : ''}`}>
        <div id="sidebar" className="flex-column">
          <Accordion defaultActiveKey={active || ''}>
            {navMenu}
            {false && <PlansBanner />}
          </Accordion>
        </div>
      </div>
    </>
  )
}

export default ApiSideBar;
